<template>
  <textarea
    type="text"
    ref="textarea"
    :placeholder="placeholder"
    maxlength="50"
    @focus="selfFocus"
    @blur="selfBlur"
    @input="textChange"
    @keydown.enter.exact.prevent.stop="enter"
    @keyup.ctrl.enter="lineFeed"
    v-model="text"
    :class="{'disabled':classDisabled,[from+'_textarea']:true,'lineH':isScroll}"
    :disabled="disabled"
  ></textarea>
</template>
<script>
export default {
  data() {
    return {
      text: "",
      isScroll:false
    };
  },
  created() {
  },
  methods: {
    selfFocus() {
      this.$emit("selfFocus");
    },
    selfBlur() {
      this.$emit("selfBlur");
    },
    enter() {
      this.$emit("enter",this.text);
	  },
	// 获取光标位置
    getCursortPosition(ctrl) {
      var CaretPos = 0; // IE
      if (document.selection) {
        ctrl.focus();
        var Sel = document.selection.createRange();
        Sel.moveStart("character", -ctrl.value.length);
        CaretPos = Sel.text.length;
      }
      // 兼容傻逼火狐
      else if (ctrl.selectionStart || ctrl.selectionStart == "0")
        CaretPos = ctrl.selectionStart;
      return CaretPos;
    },
    lineFeed() {
      let dom = this.$refs.textarea;
      let pointer = this.getCursortPosition(dom);
      let firstStr = this.text.substr(0, pointer);
      let lastStr = this.text.substr(pointer);
      if (
        this.text != "" &&
        this.text.substr(pointer - 1, 1).search(/\n/g) == -1
      ) {
        this.text = firstStr + "\n" + lastStr;
        setTimeout(() => {
          dom.setSelectionRange(pointer + 1, pointer + 1);
          dom.blur();
          dom.focus();
          this.textChange();
        }, 0);
      }
    },
    textChange(event) {
      if(this.$refs.textarea.scrollHeight>this.$refs.textarea.clientHeight){
        this.isScroll = true;
      }else{
        this.isScroll = false;
      }
      this.$emit('selfInput',this.text);
    }
  },
  props: {
    placeholder: {
      type: [String],
      default: ""
    },
    maxlength: {
      type: Number,
      default: 50
    },
    disabled: {
      type: Boolean,
      default: false
    },
    classDisabled:{
      type: Boolean,
      default: false
    },
    from:{
      type: [String],
      default: ""
    }
  }
};
</script>
<style  lang="less" rel="stylesheet/less" scoped>
textarea {
  width: 770px;
  height: 63px;
  float: left;
  line-height: 63px;
  border-radius: 4px;
  font-size: 18px;
  padding: 0 15px;
  color: #ffffff;
  caret-color: #808080;
  resize: none;
  background: #454545;
  &::-webkit-input-placeholder {
    /* Chrome/Opera/Safari */
    color: #808080;
    padding-left: 5px;
  }
}
.danmu_textarea{
  width: 600px;
  height: 46px;
  float: left;
  line-height: 46px;
  border-radius: 23px;
}
textarea.lineH{
  line-height: 32px;
}
.danmu_textarea.lineH{
  line-height: 24px;
}
.disabled {
  background: #dadada;
}
</style>




// WEBPACK FOOTER //
// src/components/bussiness/video/textarea.vue